import { action } from 'typesafe-actions';
import { PlataformaTypes, IPlataforma } from './types';

export const loadRequest = (cddAtivo: number | undefined) =>
  action(PlataformaTypes.LOAD_REQUEST, { cddAtivo });
export const loadSuccess = (data: IPlataforma[]) => action(PlataformaTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(PlataformaTypes.LOAD_FAILURE, {});
